// Theme Plugin - Initialize theme on app load

export default {
  install(Vue) {
    // Initialize theme from localStorage on app start
    const savedTheme = localStorage.getItem('protokol-theme') || 'dark'
    document.documentElement.setAttribute('data-theme', savedTheme)
    
    // Add global method to get current theme
    Vue.prototype.$getTheme = function() {
      return document.documentElement.getAttribute('data-theme') || 'dark'
    }
    
    // Add global method to set theme
    Vue.prototype.$setTheme = function(theme) {
      document.documentElement.setAttribute('data-theme', theme)
      localStorage.setItem('protokol-theme', theme)
      this.$root.$emit('theme-changed', theme)
    }
  }
}
